import React from 'react'
import { Button } from '@/components/ui/button'
import { Link, useLocation } from 'react-router-dom'

const Header = () => {
  const location = useLocation()

  return (
    <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex items-center gap-2">
          <img
            src="/lovable-uploads/d553a273-86b0-4034-bb8b-c2f63a9c0674.png"
            alt="Logo"
            className="h-8 w-8"
          />
        </div>
      </div>
    </header>
  )
}

export default Header
